module.exports = __webpack_public_path__ + "static/media/activate-success.41d40b42.png";